/**
 * Translations keyed by the English text. Each area keeps its own file; the core file
 * wins when two areas translate a key differently.
 */
import { FIL as CORE_FIL } from './fil';
import { CEB as CORE_CEB } from './ceb';
import { FIL_ASSISTANCE } from './fil-assistance';
import { FIL_MERCHANTS_OFFICE } from './fil-merchants-office';
import { FIL_MERCHANT } from './fil-merchant';
import { CEB_MERCHANT } from './ceb-merchant';
import { FIL_REGISTRY } from './fil-registry';
import { CEB_REGISTRY } from './ceb-registry';

export const FIL: Record<string, string> = { ...FIL_ASSISTANCE, ...FIL_MERCHANTS_OFFICE, ...FIL_MERCHANT, ...FIL_REGISTRY, ...CORE_FIL };
export const CEB: Record<string, string> = { ...CEB_MERCHANT, ...CEB_REGISTRY, ...CORE_CEB };
